function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useUncontrolled, useDidUpdate } from '@mantine/hooks';
import { useFloating, size, offset, shift, limitShift, flip, inline, arrow } from '@floating-ui/react';
import { useFloatingAutoUpdate } from '../Floating/use-floating-auto-update.js';
function getPopoverMiddlewares(options) {
    var middlewares = [
        offset(options.offset)
    ];
    if (options.middlewares.shift) {
        middlewares.push(shift({
            limiter: limitShift()
        }));
    }
    if (options.middlewares.flip) {
        middlewares.push(flip());
    }
    if (options.middlewares.inline) {
        middlewares.push(inline());
    }
    middlewares.push(arrow({
        element: options.arrowRef,
        padding: options.arrowOffset
    }));
    return middlewares;
}
function usePopover(options) {
    var _useUncontrolled = _sliced_to_array(useUncontrolled({
        value: options.opened,
        defaultValue: options.defaultOpened,
        finalValue: false,
        onChange: options.onChange
    }), 2), _opened = _useUncontrolled[0], setOpened = _useUncontrolled[1];
    var onClose = function() {
        var _a;
        (_a = options.onClose) == null ? void 0 : _a.call(options);
        setOpened(false);
    };
    var onToggle = function() {
        var _a, _b;
        if (_opened) {
            (_a = options.onClose) == null ? void 0 : _a.call(options);
            setOpened(false);
        } else {
            (_b = options.onOpen) == null ? void 0 : _b.call(options);
            setOpened(true);
        }
    };
    var floating = useFloating({
        placement: options.position,
        middleware: _to_consumable_array(getPopoverMiddlewares(options)).concat(_to_consumable_array(options.width === "target" ? [
            size({
                apply: function apply(param) {
                    var rects = param.rects;
                    var _a, _b;
                    Object.assign((_b = (_a = floating.refs.floating.current) == null ? void 0 : _a.style) != null ? _b : {}, {
                        width: "".concat(rects.reference.width, "px")
                    });
                }
            })
        ] : []))
    });
    useFloatingAutoUpdate({
        opened: options.opened,
        position: options.position,
        positionDependencies: options.positionDependencies,
        floating: floating
    });
    useDidUpdate(function() {
        var _a;
        (_a = options.onPositionChange) == null ? void 0 : _a.call(options, floating.placement);
    }, [
        floating.placement
    ]);
    useDidUpdate(function() {
        var _a, _b;
        if (!options.opened) {
            (_a = options.onClose) == null ? void 0 : _a.call(options);
        } else {
            (_b = options.onOpen) == null ? void 0 : _b.call(options);
        }
    }, [
        options.opened
    ]);
    return {
        floating: floating,
        controlled: typeof options.opened === "boolean",
        opened: _opened,
        onClose: onClose,
        onToggle: onToggle
    };
}
export { usePopover }; //# sourceMappingURL=use-popover.js.map
